import React from 'react'

function Heading({h1}) {
  return <h1>{h1}</h1>
}

export default Heading